module.exports = "<fx-layout-basic-side>\n\n</fx-layout-basic-side>\n"